module.exports = __webpack_public_path__ + "img/tanaka.4e375382.jpg";